export default "__VITE_ASSET__8YjBXNEK__"